
import type { GridColumn } from '../types/gridTypes';

export const validateCell = (
  value: any,
  column: GridColumn
): { message: string } | null => {
  if (!column.allowedValues && !column.type) return null;

  // Required check (implicit if we want to add required flag, currently not in type but good to have logic ready)
  if (value === null || value === undefined || value === '') {
    // If we had a required flag:
    // if (column.required) return { message: 'Value is required' };
    return null;
  }

  switch (column.type) {
    case 'number':
    case 'currency':
    case 'percent':
      if (typeof value !== 'number' && isNaN(parseFloat(value))) {
        return { message: 'Must be a number' };
      }
      break;
    case 'select':
      if (column.options && !column.options.includes(value)) {
        return { message: `Value must be one of: ${column.options.join(', ')}` };
      }
      break;
  }

  if (column.allowedValues && !column.allowedValues.includes(value)) {
     return { message: 'Value not allowed' };
  }

  return null;
};
